<template>

    <div class="volunteer">

        <div class="banner">
    <img src="@/assets/imgs/csBan.jpg" alt="">
        </div>
        <div class="wrap wx1200">
       <div class="menu-box">
                <div class="menu-crumb">
                        <el-breadcrumb separator-class="el-icon-arrow-right">

                        <el-breadcrumb-item :to="{ path: '/volunteer/home' }">志愿者之家</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/volunteer/home/rule'}" v-if="$route.name !== '志愿者之家'">{{$route.name | routeName}}</el-breadcrumb-item>
                        </el-breadcrumb>
                </div>
            </div>
            <keep-alive>
            　　<router-view  v-if="$route.meta.keepAlive" v-wechat-title='$route.meta.title' ></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive" v-wechat-title='$route.meta.title'></router-view>

              <!-- <volunteerRule></volunteerRule> -->
                <!-- <div class="content">
                    <div class="title">上饶美术馆志愿者章程</div>
                    <div class="date"> <span>发布日期：</span><span>2021-03-09</span><span> 浏览次数：</span><span>913次</span></div>
                    <div class="text">
                        欢迎加入天津美术馆志愿者队伍！<br>
                        <br>
                        服务宗旨：<br>
                        天津美术馆志愿者团队是一支以提高美术馆形象，实现公共教育与完善馆内服务为目标的生力军队伍。通过参加各种类型的公共服务和教育推广活动，引导社会公众接近艺术、了解艺术、享受艺术，普及优秀的人文精神与价值理念，加强与社会各界的文化交流，发挥自身兴趣和特长服务大众，以传播文化艺术为宗旨。
                        <br>
                        指导思想：<br>
                        1.拥护本团队章程，维护天津美术馆及本团队形象。<br>
                        2.积极参与天津美术馆活动，认真完成工作任务。<br>
                        3.自觉宣传天津美术馆宗旨，以实际行动扩大志愿者工作的社会影响力。<br>
                        <br>
                        服务规则：<br>
                        1.上岗签到：每次参加培训或岗位服务工作时都要按时、按要求签到，到岗后需要向综合办公室工作人员领取工作证件，方便观众识别。未经认证的记录不能作为志愿者晋级条件。<br>
                        2.服务记录：志愿者每周到天津美术馆内服务半天。培训记录和工作记录自加入志愿者团队时开始计算。单次工作记录超出半天时间的，按小时另行计算。如特殊情况不能到岗，应至少提前1天，向综合办公室工作人员说明。<br>
                        3.服务工作：志愿者讲解员在讲解时应做到声音洪亮，吐字清晰，表达流畅。对待观众热情、大方，做到有问必答。若观众对讲解有任何不满而提出批评或建议，应做到虚心接受，切勿与其发生争执而影响其他观众参观。在巡视服务过程中，如发现个别观众大声喧哗或在作品前使用闪光灯，志愿者有义务和责任上前劝阻，劝阻无效可交由展厅巡视人员处理。<br>
                        4.等级评比：为鼓励志愿者积极学习，保证为公众提供高质量的服务，天津美术馆对志愿者实行等级评定制度。分为初级、中级、高级、资深4个等级。根据等级，志愿者可享受不同的权益。<br>
                        5.等级认证：每次按时到岗服务，做到不迟到不早退，不擅自离岗。服务累积满30次以上者，可参与评定中级资格（橙色证件）。服务累积满50次以上者，可参与评定高级资格（红色证件）和开具在天津美术馆社会实践证明。在某项目领域表现突出的志愿者，服务满60次以上者，经天津美术馆相关部门领导审核获得资深认证。<br>
                        <br>
                        志愿者权利：<br>
                        1.在岗位确定前根据自身优势有表达选择服务岗位的权利。<br>
                        2.在服务期间志愿者有向馆内服务工作提出建议和意见的权利。<br>
                        3.在志愿服务期间有免费参观天津美术馆举办的各个展览的权利。<br>
                        4.在服务期间有优先参与天津美术馆举办的讲座及其它教育活动的权利。<br>
                        5.在服务期间志愿者可通过申请免费查阅本馆资料的权利<br>
                    </div>
                </div> -->

                <rigthBox
            :list="rigthBoxData"
            :sidebarTitle="sidebarTitle"
          ></rigthBox>
        </div>
    </div>
</template>
<script>
import rigthBox from "@/components/rigthBox";

export default {
     name: 'volunteerHome',
      components: {
    rigthBox
  },
  watch:{
  $route(to,from){

  }
},
  data(){

     return {
                sidebarTitle: "志愿者之家",
                rigthBoxData: [
                {
                name: "志愿者章程",
                index: "menu1",
                path: "/volunteer/home/rule",
                children: [],
                },
                {
                name: "志愿者活动",
                index: "menu2",
                path: "/volunteer/home/activity",
                children: [],
                },

            ],
             }

  },
   filters:{
                routeName:function(val)
                {
                     switch(val)
                     {
                          case 'volunteerHome':  return '志愿者之家';
                          case 'volunteerRule':  return '志愿者章程';
                          case 'volunteerActivityRegister':  return '志愿者章程';
                          case 'volunteerActivity':  return '志愿者活动';
                          case 'volunteerActivityDetail':  return '志愿者活动';
                          default: return '志愿者章程';
                     }
                },

            },
  created()
  {
            console.log(1)
  },
    mounted: function () {
      console.log(2)
    },
    activated: function () {
   //this.$router.push({ path: "/volunteer/home/rule"});
        console.log(3)
    },
    deactivated: function () {
      console.log(4)
    },
  methods:
  {

        danji(event)
        {
            console.log(event.target);
        }
  }
}
</script>
<style scoped>
img {
    font-size: 18px;
}
    .volunteer {
        padding-top:1.111111rem /* 80px -> 1.111111rem */;
        padding-bottom:0.833333rem /* 60px -> 0.833333rem */;
        width: 100%;
        height: 100%;
        font-family: SourceHanSansCN-;
        font-weight: 500;
        font-size: 18px;
        background-color: #f4f4f4;
    }
    .volunteer .banner {
        width: 100%;
    }
    .volunteer .banner > img {
        width: 100%;
        height: auto;
    }

    .volunteer .wrap {
        margin: 0 auto;
        padding-top: 60px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
       .menu-box {
         width: 100%;
     }
     .menu-crumb {
    width: 300px;
    height: 18px;
    line-height: 18px;
    }
    .menu-box   >>> .el-breadcrumb__item .el-breadcrumb__inner
    {
       font-family:Arial,Verdana,Sans-serif;
        color: #999999;

    }
      .menu-box  >>> .el-breadcrumb__item .el-breadcrumb__inner.is-link {
            font-weight: 400;
               color: #999999;
                   cursor: pointer;
     }
       .menu-box  >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner.is-link  {
        color: #303133;
        font-weight: 500;
     }
    .wx1200 {
        width: 1200px;
    }

</style>
